import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class BatchLotUpV2Model extends BaseModel {
  uuid = null;

  rules = {
  };

  attributeLabels = {
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}

